module.exports = __webpack_public_path__ + "static/media/flyp_logo_colored.0c0428b2.png";